import React from 'react';
import { Bell, CheckCheck, Loader2, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../ui/Modal';
import { formatDistanceToNow } from '../utils/time';
import { useUIStore } from '../../stores/uiStore';

export const NotificationPanel: React.FC = () => {
  const { notifications, notificationsLoading, notifPanelOpen, closeNotifPanel, markRead, markAllRead, lang } = useUIStore();
  const navigate = useNavigate();
  const isRTL = lang === 'ar';
  const unread = notifications.filter(item => !item.read).length;

  const handleClick = async (id: string, route?: string) => {
    try {
      await markRead(id);
      if (route) { closeNotifPanel(); navigate(route); }
    } catch { /* the store restores the optimistic state and reports the error */ }
  };

  return <Modal
    open={notifPanelOpen}
    onClose={closeNotifPanel}
    size="md"
    ariaLabel={isRTL ? 'التنبيهات' : 'Notifications'}
    closeLabel={isRTL ? 'إغلاق التنبيهات' : 'Close notifications'}
    viewportClassName="notification-dialog-viewport"
    className={`notification-dialog-panel ${isRTL ? '[direction:rtl] text-right' : ''}`}
  >
    <header className="notification-dialog-header">
      <div className="notification-dialog-title">
        <Bell size={19} aria-hidden="true" />
        <h2>{isRTL ? 'التنبيهات' : 'Notifications'}</h2>
        {unread > 0 && <span className="notification-count" aria-label={isRTL ? `${unread} غير مقروء` : `${unread} unread`}>{unread}</span>}
      </div>
      <div className="notification-dialog-actions">
        <button type="button" onClick={() => void markAllRead().catch(() => undefined)} className="icon-control" disabled={unread === 0 || notificationsLoading} aria-label={isRTL ? 'تعليم الكل كمقروء' : 'Mark all read'}>
          <CheckCheck size={17} />
        </button>
        <button type="button" onClick={closeNotifPanel} className="icon-control" aria-label={isRTL ? 'إغلاق التنبيهات' : 'Close notifications'}><X size={17} /></button>
      </div>
    </header>
    <div className="notification-dialog-list">
      {notificationsLoading ? <div className="notification-empty"><Loader2 className="animate-spin" size={28} /><p>{isRTL ? 'جارٍ تحميل التنبيهات' : 'Loading notifications'}</p></div>
        : notifications.length === 0 ? <div className="notification-empty"><Bell size={30} /><p>{isRTL ? 'لا توجد تنبيهات' : 'No notifications'}</p></div>
          : notifications.map(item => <button
              key={item.id}
              type="button"
              onClick={() => void handleClick(item.id, item.linkRoute)}
              className="notification-row"
              data-unread={!item.read}
            >
              <span className={`notification-status is-${item.type}`} aria-hidden="true" />
              <span className="notification-copy">
                <strong>{isRTL ? item.titleAr : item.titleEn}</strong>
                <span>{isRTL ? item.bodyAr : item.bodyEn}</span>
                <time dateTime={item.createdAt}>{formatDistanceToNow(item.createdAt, isRTL)}</time>
              </span>
            </button>)}
    </div>
  </Modal>;
};
